import React from "react";
//import PropTypes from 'prop-types';

import {
    ListItem as BaseListItem,
    MenuItems as BaseMenuItems,
} from "playground/cms/views/Resources";
import { useData } from "state/hooks";

function Area({ value }) {
    const rounded = Math.round(value * 100) / 100;
    if (!rounded) return null;
    return (
        <span>
            {rounded} m<sup>2</sup>
        </span>
    );
}

export function ListItem(props) {
    const {} = props;
    const data = useData(props);
    const secondary = data?.stats?.rooms?.counts;
    const area = data?.total_area;
    return (
        <BaseListItem
            {...props}
            primaryTextProperties={["name", "code_part"]}
            secondaryText={secondary}
            avatar={<div className={"status-dot"} data-status={data.status} />}
        >
            <Area value={area} />
        </BaseListItem>
    );
}

ListItem.propTypes = {};

ListItem.defaultProps = {};

export default ListItem;
